export const state = () => ({
  loading: false,

  updateFilters: false,
  updateProducts: false,
});

export const mutations = {
  setLoading: function (state, bool) {
    state.loading = bool;
  },
  setLoadingKey: function (state, { key, value }) {
    state[key] = value;
  },
};
export const getters = {
  loading: ({ loading }) => loading,
};
